module.exports = __webpack_public_path__ + "media/images/optimizer_restart-ee810f84c13afb50e8d94bf828635321.png";